var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgCommentStackLine = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "comment-stack-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.25 19C20.25 19.6904 19.6904 20.25 19 20.25L5 20.25C4.30964 20.25 3.75 19.6904 3.75 19L3.75 15C3.75 14.3096 4.30964 13.75 5 13.75L19 13.75C19.6904 13.75 20.25 14.3096 20.25 15V19ZM20.25 9C20.25 9.69036 19.6904 10.25 19 10.25L5 10.25C4.30964 10.25 3.75 9.69035 3.75 9L3.75 5C3.75 4.30964 4.30964 3.75 5 3.75L19 3.75C19.6904 3.75 20.25 4.30965 20.25 5V9Z",
    strokeWidth: 1.5
  }))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgCommentStackLine);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/comment-stack-line.368aa6d75ad78de8ed43f551b3477dd1.svg";